import React from 'react';

import { Chip } from '@mui/material';

import { ContentSourceInfo } from '~/services/AccommodationService';

type SourceType = ContentSourceInfo['type'];

const SOURCE_TYPE_COLOR_MAP: Record<SourceType, 'info' | 'success' | 'warning' | 'secondary' | 'default'> = {
  bedbank_property: 'info',
  bedbank_room: 'info',
  reservation_property: 'success',
  reservation_room: 'success',
  custom: 'warning',
  generated: 'secondary',
  offer: 'default',
  offer_package: 'default',
};

const SOURCE_TYPE_LABEL_MAP: Record<SourceType, string> = {
  bedbank_property: 'Bedbank Property',
  bedbank_room: 'Bedbank Room',
  reservation_property: 'Reservation Property',
  reservation_room: 'Reservation Room',
  custom: 'Custom',
  generated: 'Generated',
  offer: 'Offer',
  offer_package: 'Offer Package',
};

interface ContentSourceChipProps {
  type: SourceType;
}

export default function ContentSourceChip({ type }: ContentSourceChipProps) {
  return (
    <Chip size="small" color={SOURCE_TYPE_COLOR_MAP[type] ?? 'default'} label={SOURCE_TYPE_LABEL_MAP[type] ?? type} />
  );
}
